import { USER_ROLE, USER_TYPE } from "../../Util/constants";

export const UHID_DUPLICATE_ERROR =
  "This record is already exists, please enter unique record.";

export const getUHIDFormatError = (uhIDPrefix) => {
  return `Kindly enter valid UHID Ex- ${uhIDPrefix ? uhIDPrefix : "ABC"}0001`;
};

export const CHECK_HAS_RESOURCE_ACCESS = (userType, doctorRole, isResource) => {
  return (
    doctorRole === USER_ROLE.RESOURCE_ADMIN ||
    doctorRole === USER_ROLE.RESOURCE_CONSULTANT ||
    (doctorRole === USER_ROLE.DOCTOR_ADMIN && isResource) ||
    (userType === USER_TYPE.STAFF && isResource)
  );
};

export const BOOKING_TYPES = [
  {
    label: "Clinic",
    value: "Clinic",
  },
  {
    label: "Laboratory",
    value: "Laboratory",
  },
];

export const BOOKING_TYPE = {
  CLINIC: "Clinic",
  LABORATORY: "Laboratory",
};

export const UHID_SINGLE_QUOTES_ERROR =
  "UHID field cannot take single & double quotes. Kindly enter something else.";

export const EMAIL_REGEX = RegExp(/[\w-]+@([\w-]+\.)+[\w-]+/);
export const PINCODE_REGEX = RegExp(/^[1-9]\d{5}$/);
export const STATE_LIST = [
  // { label: '', value: '' },
  { label: "Andhra Pradesh", value: 37 },
  { label: "Arunachal Pradesh", value: 12 },
  { label: "Assam", value: 18 },
  { label: "Bihar", value: 10 },
  { label: "Chattisgarh", value: 22 },
  { label: "Delhi", value: 7 },
  { label: "Goa", value: 30 },
  { label: "Gujarat", value: 24 },
  { label: "Haryana", value: 6 },
  { label: "Himachal Pradesh", value: 2 },
  { label: "Jammu and Kashmir", value: 1 },
  { label: "Jharkhand", value: 20 },
  { label: "Karnataka", value: 29 },
  { label: "Kerala", value: 32 },
  { label: "Lakshadweep Islands", value: 31 },
  { label: "Madhya Pradesh", value: 23 },
  { label: "Maharashtra", value: 27 },
  { label: "Manipur", value: 14 },
  { label: "Meghalaya", value: 17 },
  { label: "Mizoram", value: 15 },
  { label: "Nagaland", value: 13 },
  { label: "Odisha", value: 21 },
  { label: "Pondicherry", value: 34 },
  { label: "Punjab", value: 3 },
  { label: "Rajasthan", value: 8 },
  { label: "Sikkim", value: 11 },
  { label: "Tamil Nadu", value: 33 },
  { label: "Telangana", value: 36 },
  { label: "Tripura", value: 16 },
  { label: "Uttar Pradesh", value: 9 },
  { label: "Uttarakhand", value: 5 },
  { label: "West Bengal", value: 19 },
  { label: "Andaman And Nicobar Islands", value: 35 },
  { label: "Chandigarh", value: 4 },
  { label: "Dadra and Nagar Haveli", value: 26 },
  { label: "Daman and Diu", value: 25 },
  { label: "Ladakh", value: 38 },
];
export const reationStyles = {
  control: (base) => ({
    ...base,
    width: "100%",
    background: " #F5F6F7 0% 0% no-repeat padding-box",
    boxShadow: "none",
    border: "none",
    cursor: "pointer",
    height: "38px !important",
    "&:hover": {
      boxShadow: "none",
    },
  }),
  container: (base) => ({
    ...base,
    width: "100%",
    textAlign: "left",
  }),
  placeholder: (styles, { data }) => {
    return {
      ...styles,
      fontSize: "14px",
    };
  },
  menuList: (provided) => ({
    ...provided,
    maxHeight: "200px !important",
    "&::-webkit-scrollbar": {
      width: "14px",
      height: "16px",
      display: "block !important",
      background: "none",
    },
    "&::-webkit-scrollbar-track": {
      background: "none",
      borderRadius: "10px",
    },
    "&::-webkit-scrollbar-thumb": {
      boxShadow: "inset 0 0 16px rgba(240, 232, 232, 1)",
      minHeight: "60px !important",
    },
  }),
  singleValue: (provided, { data }) => ({
    ...provided,
    fontSize: "14px",
    color: data.value === "1" ? "#A3A9B7" : "#1B2027",
  }),
  clearIndicator: (provided) => ({
    ...provided,
    background: "#f5f5f5",
  }),
  option: (provided, { data, isDisabled, isFocused, isSelected }) => {
    let optionColor = "#1B2027";
    if (data.value === "1") {
      optionColor = "#A3A9B7";
    } else if (isSelected) {
      optionColor = "#fff";
    }

    return {
      ...provided,
      cursor: "pointer",
      backgroundColor: isSelected && data.value !== "1" ? "#17bae0" : null,
      color: optionColor,
    };
  },
};
export const customStyles = {
  control: (base) => ({
    ...base,
    width: "100%",
    background: " #F5F6F7 0% 0% no-repeat padding-box",
    border: "1px solid #DBDBDB",
    borderRadius: "5px",
    height: "36px",
  }),
  container: (base) => ({
    ...base,
    width: "100%",
    textAlign: "left",
  }),
};

export const PATIENT_ABHA_VERIFICATION_TAB = [
  {
    id: 1,
    label: "Aadhar Number",
    name: "aadhar-number",
    value: 1,
  },
  {
    id: 2,
    label: "ABHA Number",
    name: "abha-number",
    value: 2,
  },
  {
    id: 3,
    label: "Mobile Number",
    name: "mobile-number",
    value: 3,
  },
];

export const AADHAR_VALIDATION_ERROR = {
  FIRST_ERROR: "Enter valid Aadhaar Number",
  SECOND_ERROR: "Aadhar not verified. Please try again.",
  THIRD_ERROR: "Try again after 30 minutes",
};

export const OTP_VALIDATION_ERROR = {
  FIRST_ERROR: "Enter valid OTP",
  SECOND_ERROR: "OTP verification failed.",
  THIRD_ERROR:
    "Maximum OTP Resend attempts Exceeded. Please try again in 30 mins.",
};

export const SLOT_STATUS = {
  SUCCESS: "success",
  FAILURE: "failure",
};
